import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from 'react-country-flag';
import Select from 'react-select';
import Logo from '../../assets/img/logo.png';

const Header = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const { t, i18n } = useTranslation('header');
    const navigate = useNavigate();

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang.value);
        localStorage.setItem('i18nextLng', lang.value);
    };

    const languageOptions = [
        {
            value: 'ptbr',
            label: (
                <div className="language-option" style={{ textAlign: 'center'}}>
                    <ReactCountryFlag countryCode="BR" svg />
                </div>
            )
        },
        {
            value: 'ptpt',
            label: (
                <div className="language-option" style={{ textAlign: 'center'}}>
                    <ReactCountryFlag countryCode="PT" svg />
                </div>
            )
        },
        {
            value: 'en',
            label: (
                <div className="language-option" style={{ textAlign: 'center'}}>
                    <ReactCountryFlag countryCode="GB" svg />
                </div>
            )
        },
        {
            value: 'fr',
            label: (
                <div className="language-option" style={{ textAlign: 'center'}}>
                    <ReactCountryFlag countryCode="FR" svg />
                </div>
            )
        },
        {
            value: 'es',
            label: (
                <div className="language-option" style={{ textAlign: 'center'}}>
                    <ReactCountryFlag countryCode="ES" svg />
                </div>
            )
        }
    ];

    return (
        <>
            <header className={`main-header ${isScrolled ? 'fixed-header' : ''}`}>
                <div className="header-container container">
                    <Link to="/" className="logo-button">
                        <img src={Logo} alt="Logo The Worky" className="logo-container" />
                    </Link>

                    <nav>
                        <ul className={menuOpen ? "nav-menu open" : "nav-menu"}>
                            <li className="normal-btn"><Link to="/sobre">{t('about')}</Link></li>
                            <li className="normal-btn"><Link to="/servicos">{t('services')}</Link></li>
                            <li className="normal-btn"><Link to="/vagas">{t('jobs')}</Link></li>
                            <li className="normal-btn">
                            </li>
                            <li className="normal-btn">
                                <button className="open-resume-btn" onClick={() => navigate('/cadastro?modal=curriculo')}>
                                    {t('register')}
                                </button>
                            </li>
                        </ul>

                        <button className="mobile-btn" onClick={() => setMenuOpen(!menuOpen)}>
                            {menuOpen ? <FaTimes /> : <FaBars />}
                        </button>
                    </nav>

                    {/* Dropdown de Idiomas */}
                    <div className="language-selector">
                        <Select
                            options={languageOptions}
                            onChange={changeLanguage}
                            className="language-dropdown"
                            placeholder="🌐"
                            isSearchable={false}
                        />
                    </div>
                </div>
            </header>

            <div className="header-spacer"></div>
        </>
    );
};

export default Header;
